import popupClass from "./PopupClass";
import {fetchRequestSend, getCookieHelper, setCookieHelper} from "../../helpers/common-helpers";
import HubspotIntegrationClass from "./HubspotIntegrationClass";
import FormValidationClass from "./FormValidationClass";
import FormValidationMessagesClass from "./FormValidationMessagesClass";
import PreloaderClass from "./PreloaderClass";
export default class QuickReferencesDownloadClass {
    vsPopupClassInit = new popupClass();
    constructor() {
        this.initializeEventListeners();
        this.submitQRForm();
    }


    initializeEventListeners() {
        window.addEventListener('click', e => {
            if (e.target.closest('.download-courseware__js')) {
                e.preventDefault();
                //console.log(getCookieHelper('__email_cg'));
                this.downloadCoursewareRun(e.target.closest('.download-courseware__js'));
            }
        });
    }

    downloadCoursewareRun(element) {
        let name = element.dataset.cw_name;
        let qr_id = element.dataset.qr_id;
        if(document.getElementById('qr-webform')){
            if(!getCookieHelper('__email_cg')){
                this.insertHiddenHSForm();
                this.vsPopupClassInit.open('qr-webform-popup');
                document.getElementById('qr-webform').dataset.qr_id = qr_id;
                //set get parameter with qr_name to page url
                if(name !== undefined) {
                    let url_page = new URL(window.location.href);
                    // make qr in lovercase and with glyph
                    name = name.toLowerCase();
                    name = name.replace(/ /g, '-');
                    // add "-quick-reference" to end of qr_name
                    name = name + '-quick-reference';
                    url_page.searchParams.set('qr_name', name);
                    window.history.replaceState({}, '', url_page);
                }

            }
            else{
                this.downloadCourseware(element);
            }

            // this.downloadCourseware(element);
        } else {
            fetch(receivePrivateURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    qr_id: qr_id
                })
            }).then(response => {
                if(response.ok) {
                    element.dataset.href = response.url;
                    // const contentType = response.headers.get('Content-Type');
                    // if (contentType && contentType.toLowerCase().includes('application/pdf')) {
                    //     return response.blob(); // Convert response to Blob for PDF
                    // } else if (contentType && contentType.toLowerCase().includes('application/json')) {
                    //     return response.json(); // Parse JSON response
                    // } else {
                    //     return response.json();
                    // }
                }else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            })
                .then(data => {
                    if (data instanceof Blob) {
                        const pdfUrl = URL.createObjectURL(data);
                        window.open(pdfUrl, '_blank');
                    } else {
                        window.open(data.url, '_blank');
                    }
                })
                .catch(error => {
                    response.text().then(content => console.error('Response Content:', content));
                });
        }
    }

    insertHiddenHSForm() {
        const popup = document.getElementById('qr-webform-popup');
        const hasHiddenForm = document.querySelector('.hs-hidden-form');
        const isLive = window.location.host === 'www.customguide.com';

        if (popup && isLive && !hasHiddenForm) {
            // Create the hidden container
            const container = document.createElement('div');
            container.classList.add('hs-hidden-form');
            container.hidden = true;
            popup.appendChild(container);

            // Load the HubSpot forms script dynamically
            const script = document.createElement('script');
            script.src = '//js.hsforms.net/forms/embed/v2.js';
            script.onload = function () {
                hbspt.forms.create({
                    portalId: "44251873",
                    formId: "33405c70-68c8-4c43-8ee8-0cb6aa2119bd",
                    region: "na1",
                    target: '.hs-hidden-form'
                });
            };
            document.head.appendChild(script);
        }
    }

    downloadCourseware(element, url_live = null) {
        let url = element.dataset.url;
        let cw_name = element.dataset.cw_name;
        let currentUrl = window.location;
        let baseUrl = '';
        let win = '';
        ////********* */base url for local and dev website *******//
        if (currentUrl.host !=='www.customguide.com') {
            let urlFirstPart = url.split('/')[1];

            if (urlFirstPart == currentUrl.pathname.split('/')[1]){
                baseUrl = currentUrl .protocol + "//" + currentUrl.host
            }
        }
        else {
            ////********* */base url for live website *******//
            baseUrl = currentUrl .origin;
        }
        if (url.split('/')[0] == currentUrl .protocol && url.split('/')[2] == currentUrl.host){
            let lastSegment = url.split('/').pop() || url.split('/').pop();
            let extension = lastSegment.substr( (lastSegment.lastIndexOf('.') +1) );
            if(extension !== 'zip'){
                win = window.open(url, '_blank');
            }
            else{
                win = window.open(url, '_self');
            }
        }
        else{
            win = window.open(baseUrl+url, '_blank');
            if (win) {
                //Browser has allowed it to be opened
                win.focus();
            } else {
                //Browser has blocked it

            }
        }
    }

     coursewareForm(documentUrl, cw_name){
        if(!getCookieHelper('__email_cg')){
            if (documentUrl.indexOf("outline") > -1 || documentUrl.indexOf("esquema") > -1) {
                this.downloadCourseware(documentUrl);
            }
            else if(documentUrl.indexOf("cheat-sheet") > -1){
                new vsPopupClass().open('qr-webform-popup');
                fileName = documentUrl;
            }
            else{
                new vsPopupClass().open('cw-webform-popup');
                fileName = documentUrl;
            }
        }
        else{
            this.downloadCourseware(documentUrl);
        }
    }

    submitQRForm() {
        let form = document.getElementById('qr-webform');
        if(!form) return;
        form.addEventListener('submit', e => {
            e.preventDefault();
            PreloaderClass.forPopup('qr-webform-popup');
            // check validation
            const validation = new FormValidationClass('qr-webform').init();
            if(validation) {
                // send form to hubspot
                new HubspotIntegrationClass().sendForm(form);
                PreloaderClass.stop();
                // redirect to download page
                let qr_element = document.querySelector(`[data-qr_id="${form.dataset.qr_id}"]`);
                this.downloadCourseware(qr_element);
                let email = form.querySelector('input[name="email"]').value;
                // clear form
                setCookieHelper('__email_cg', email, { expires: 2592000, path: '/' });
                form.reset();
                // close popup
                new popupClass().close('qr-webform-popup');
            } else {
                PreloaderClass.stop();
            }
        });
    }

}
